module Hereabout.UI.Bits where

import Prelude

import Data.Array.Partial as A
import Halogen as H
import Halogen.HTML as HH
import Halogen.HTML.Events as HE
import Halogen.HTML.Properties as HP
import Hereabout.Types (Content(..))
import Hereabout.UI.Bulma.Classes as Bulma
import Partial.Unsafe (unsafePartial)

renderIcon ∷ ∀ (s ∷ Type) (a ∷ Type). String → HH.HTML s a → HH.HTML s a
renderIcon icon iconContent = 
  HH.span [ HP.classes [ Bulma.iconText ]]
    [ HH.span [ HP.classes [ Bulma.icon ] ]
      [ HH.i [ HP.classes [ Bulma.fas, H.ClassName icon, Bulma.mr1  ] ]
        [
        ]
      ]
    , HH.span_
      [ iconContent
      ]
    ]

renderIconWithTitle ∷ ∀ (s ∷ Type) (a ∷ Type). String → String → HH.HTML s a → HH.HTML s a
renderIconWithTitle icon title iconContent = 
  HH.span [ HP.classes [ Bulma.iconText ], HP.title title ]
    [ HH.span [ HP.classes [ Bulma.icon ] ]
      [ HH.i [ HP.classes [ Bulma.fas, H.ClassName icon, Bulma.mr1  ] ]
        [
        ]
      ]
    , HH.span_
      [ iconContent
      ]
    ]
